import React from "react";
import { setPromptNode } from "../../utils/promptStore";
import { PromptHighlight, BenefitList, BenefitItem, Checkmark } from "./styles";

const BENEFITS = [
  "Download unlimited .mp3s under Creative Commons",
  "Access to the multitrack editor for additional songs",
  "Create playlists and organize your music"
];

const SignupGatePrompt = () => (
  <>
    Logged-out download limit reached.{" "}
    <PromptHighlight>Create a free account</PromptHighlight> to:
    <BenefitList>
      {BENEFITS.map(text => (
        <BenefitItem key={text}>
          <Checkmark>✓</Checkmark>
          <span>{text}</span>
        </BenefitItem>
      ))}
    </BenefitList>
  </>
);

export const promptSignupGate = (history: any, location: any) => {
  setPromptNode(<SignupGatePrompt />);
  history.push("/signup", { background: location });
};

export default SignupGatePrompt;
